export default "__VITE_ASSET__Bp9Xim_9__"